export default function CUnions() {
  return <h2>C Unions</h2>;
}
